<script setup>
import {computed, onMounted, ref, watch} from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import PageTitle from "@/components/common/PageTitle.vue";
import {getAvailableActionsForRoute} from "@/services/api/permissionManagement.js";
import {handleError} from "@/utils/errors.js";
import SkeletonLoader from "@/components/common/SkeletonLoader.vue";
import {PagesPermittedAccess} from "@/enums/enums.js";

const props = defineProps({
    entity: { type: Object, required: true },
    loadingMounted:{ type: Boolean, default: null }
});

const { t } = useI18n();
const route = useRoute();
const actions = ref([]);
const isLoaded = ref(null);
const havePermissions = ref(null);
const refLoadingMounted = ref(null);
const path = route.path;

const pageMode = computed(() => {
    if (path.includes("/edit")) return "edit";
    if (path.includes("/view")) return "view";
    if (path.includes("/new") || path.includes("/create")) return "create";
    return "list";
});

watch(
    () => props.loadingMounted,
    newVal => {
        refLoadingMounted.value = newVal;
    }
);

const currentPageConfig = computed(() => props.entity.pages?.[pageMode.value] ?? {});

const pageTitle = computed(() => {
    const titleKey = currentPageConfig.value.pageTitle ?? props.entity.i18n?.[pageMode.value];
    return titleKey ? t(titleKey) : "";
});


const breadcrumbs = computed(() => {
    const items = [];
    const currentConfig = currentPageConfig.value;

    const pathI18n = currentConfig.pathI18n ?? "";
    const routeList = Array.isArray(currentConfig.route) ? currentConfig.route : [];

    if (pathI18n) {
        const pathSegments = pathI18n.split("/").filter(Boolean);

        pathSegments.forEach((segment, index) => {
            const labelKey = segment;
            const route = routeList[index] ?? null; // pega o to correspondente, se existir

            items.push({
                label: t(labelKey, labelKey),
                to: route ? `${route}` : null,
            });
        });
    }

    if ((pageMode.value === "edit" || pageMode.value === "view")  && props.entity.currentName) {
        items.push({
            label: `${pageTitle.value} ${props.entity.currentName}`,
            to: null,
        });
    } else {
        items.push({ label: pageTitle.value, to: null });
    }

    return items;
});

onMounted(async () => {
    try {
        isLoaded.value = true;
        // if(path.includes(PagesPermittedAccess)) {
            // actions.value = await getAvailableActionsForRoute(props.entity.APIRoute);

            // if (actions.value && actions.value[pageMode.value]) {
        havePermissions.value = true;
            // } else {
            //     havePermissions.value = false;
            // }
        // } else {
        //     havePermissions.value = true;
        // }

    } catch (error) {
        console.error(error);
        message.error(await handleError(error, t));
    } finally {
        isLoaded.value = false;
    }
});

</script>


<template>
    <div v-if="havePermissions">
        <PageTitle :title="pageTitle" :breadcrumbs="breadcrumbs" />
        <v-card v-if="refLoadingMounted || refLoadingMounted === null && loadingMounted === null" class="bg-white trezo-card  base-page-height">
            <slot />
        </v-card>
        <SkeletonLoader v-else :page="pageMode" />
    </div>
    <div v-else-if="isLoaded && !havePermissions">
        <v-alert class="text-danger">
            {{ t("common.messages.errors.403") }}
        </v-alert>
    </div>
</template>
